import addressActions from './addressActions'
import auditActions from './auditActions'
import jobs from './jobs'
import jobDetails from './jobDetails'
import jobAttachmentActions from './jobFunctions/jobAttachmentActions'
import dobAttachmentActions from './jobFunctions/dobAttachmentActions'
import jobContactActions from './jobFunctions/jobContactActions'
import jobDrawingActions from './jobFunctions/jobDrawingActions'
import jobEstimateActions from './jobFunctions/jobEstimateActions'
import jobFollowUpActions from './jobFunctions/jobFollowUpActions'
import jobNoteActions from './jobFunctions/jobNoteActions'
import jobPaymentRequestActions from './jobFunctions/jobPaymentRequestActions'
import jobAiaActions from './jobFunctions/jobAiaActions'
import jobInvoiceActions from './jobFunctions/jobInvoiceActions'
import jobVendorActions from './jobFunctions/jobVendorActions'
import dobNoteActions from './jobFunctions/dobNoteActions'
import violationActions from './jobFunctions/violationActions'
import jobSiteOverviewActions from './jobFunctions/jobSiteOverviewActions'
import jobSiteMaterialRequestActions from './jobFunctions/jobSiteMaterialRequestActions'
import jobSiteWorkOrderActions from './jobFunctions/jobSiteWorkOrderActions'
import jobSiteServiceOrderActions from './jobFunctions/jobSiteServiceOrderActions'
import jobSiteChangeOrderActions from './jobFunctions/jobSiteChangeOrderActions'
import jobSiteEstimateActions from './jobFunctions/jobSiteEstimateActions'
import jobSitePurchaseOrderActions from './jobFunctions/jobSitePurchaseOrderActions'
import jobSiteDocumentActions from './jobFunctions/jobSiteDocumentActions'
import jobSiteJobMinuteActions from './jobFunctions/jobSiteJobMinuteActions'
import jobSiteDriverRequestActions from './jobFunctions/jobSiteDriverRequestActions'
import jobSiteTransmittalActions from './jobFunctions/jobSiteTransmittalActions'
import jobSiteRFIActions from './jobFunctions/jobSiteRFIActions'
import jobStopCallActions from './jobFunctions/jobStopCallActions'
import scheduleDrawingActions from './jobFunctions/scheduleDrawingActions'
import scheduleManufacturingActions from './jobFunctions/scheduleManufacturingActions'
import scheduleApplicationActions from './jobFunctions/scheduleApplicationActions'
import scheduleSiteWorkActions from './jobFunctions/scheduleSiteWorkActions'
import scheduleRepairActions from './jobFunctions/scheduleRepairActions'
import jobFinancialSummary from './jobFunctions/jobFinancialSummaryActions'
import itemActions from './jobFunctions/itemActions'
import purchaseOrder from './jobFunctions/purchaseOrderActions'
import estimateTemplate from './jobFunctions/estimateTemplateActions'
import workOrderTemplatesActions from './jobFunctions/workOrderTemplatesActions'
import materialRequestTemplatesActions from './jobFunctions/materialRequestTemplatesActions'
import driverRequestTemplatesActions from './jobFunctions/driverRequestTemplatesActions'
import jobPartActions from './jobFunctions/jobPartActions'
import userActions from './userActions'
import itemsActions from './itemsActions'
import leadsActions from './leadsActions'
import leadDetails from './leadDetails'
import leadAttachmentActions from './leadFunctions/leadAttachmentActions'
import leadContactActions from './leadFunctions/leadContactActions'
import leadEstimateActions from './leadFunctions/leadEstimateActions'
import leadProposalActions from './leadFunctions/leadProposalActions'
import leadContractActions from './leadFunctions/leadContractActions'
import leadFollowUpActions from './leadFunctions/leadFollowUpActions'
import leadNoteActions from './leadFunctions/leadNoteActions'
import leadRFIActions from './leadFunctions/leadRFIActions'
import leadTransmittalActions from './leadFunctions/leadTransmittalActions'
import proposalTemplate from './leadFunctions/proposalTemplateActions'
import contractTemplate from './leadFunctions/contractTemplateActions'
import companiesActions from './companiesActions'
import vendorsActions from './vendorsActions'
import contactsActions from './contactsActions'
import employeesActions from './employeesActions'
import tasksActions from './tasksActions'
import helpActions from './helpActions'
import driverRequestActions from './driverRequestActions'
import driverActions from './driverActions'
import vehiclesActions from './vehiclesActions'
import usersActions from './usersActions'
import templatesActions from './templatesActions'
import organizationsActions from './organizationsActions'
import agreementActions from './jobFunctions/jobAgreementActions'
import jobSiteTicketActions from './jobFunctions/jobSiteTicketActions'
import proposalActions from './proposalActions'
import contractActions from './contractActions'
import serviceOrderTemplatesActions from './jobFunctions/serviceOrderTemplatesActions'
import dashboardActions from './dashboard/dashboardActions'
import activityReportActions from './reports/general/activityReportActions'
import openItemsReportActions from './reports/general/openItemsReportActions'
import purchaseOrdersReportActions from './reports/general/purchaseOrdersReportActions'
import jobMinutesReportActions from './reports/general/jobMinutesReportActions'
import toolsReportActions from './reports/general/toolsReportActions'
import scheduleReportActions from './reports/general/scheduleReportActions'
import aiasReportActions from './reports/financial/aiasReportActions'
import maintenanceFinancialsReportActions from './reports/financial/maintenanceFinancialsReportActions'
import paymentRequestReportActions from './reports/financial/paymentRequestReportActions'
import invoicesReportActions from './reports/financial/invoicesReportActions'
import activeJobContractsReportActions from './reports/financial/activeJobContractsReportActions'
import stopCallsReportActions from './reports/maintenance_dob/stopCallsReportActions'
import violationsReportActions from './reports/maintenance_dob/violationsReportActions'
import targetedMonthlyVisitsReportActions from './reports/maintenance_dob/targetedMonthlyVisitsReportActions'
import applicationSchedulesReportActions from './reports/maintenance_dob/applicationSchedulesReportActions'
import maintenanceSchedulesReportActions from './reports/maintenance_dob/maintenanceSchedulesReportActions'
import ticketsReportActions from './reports/maintenance_dob/ticketsReportActions'
import leadsReportActions from './reports/leads/leadsReportActions'
import proposalsSentReportActions from './reports/leads/proposalsSentReportActions'
import contractsSentReportActions from './reports/leads/contractsSentReportActions'
import jobsReportActions from './reports/jobs/jobsReportActions'
import confirmedShipmentDatesReportActions from './reports/jobs/confirmedShipmentDatesReportActions'
import transmittalsReportActions from './reports/jobs/transmittalsReportActions'
import rfisReportActions from './reports/jobs/rfisReportActions'
import siteWorkSchedulesReportActions from './reports/jobs/siteWorkSchedulesReportActions'
import manufacturingScheduleReportActions from './reports/jobs/manufacturingScheduleReportActions'
import drawingSchedulesReportActions from './reports/jobs/drawingSchedulesReportActions'
import drawingsReportActions from './reports/jobs/drawingsReportActions'
import changeOrdersReportActions from './reports/jobs/changeOrdersReportActions'
import financialSchedulesReportActions from './reports/jobs/financialSchedulesReportActions'
import jobSiteRepairOrderActions from './jobFunctions/jobSiteRepairOrderActions'
import scheduledDeliveriesActions from './scheduledDeliveriesActions'
import testingActions from './jobFunctions/testingActions'

import revisionActions from './revisionActions'

import authentication from './authentication'

export default {
  addressActions,
  auditActions,
  jobs,
  jobDetails,
  jobAttachmentActions,
  dobAttachmentActions,
  jobContactActions,
  jobDrawingActions,
  jobFollowUpActions,
  jobEstimateActions,
  jobNoteActions,
  jobPaymentRequestActions,
  jobAiaActions,
  jobInvoiceActions,
  jobVendorActions,
  dobNoteActions,
  violationActions,
  jobSiteOverviewActions,
  jobSiteMaterialRequestActions,
  jobSiteWorkOrderActions,
  jobSiteServiceOrderActions,
  jobSiteChangeOrderActions,
  jobSiteEstimateActions,
  jobSitePurchaseOrderActions,
  jobStopCallActions,
  jobSiteDocumentActions,
  jobSiteJobMinuteActions,
  jobSiteDriverRequestActions,
  jobSiteTransmittalActions,
  jobSiteRFIActions,
  scheduleDrawingActions,
  scheduleManufacturingActions,
  scheduleApplicationActions,
  scheduleSiteWorkActions,
  scheduleRepairActions,
  jobFinancialSummary,
  itemActions,
  purchaseOrder,
  estimateTemplate,
  userActions,
  itemsActions,
  leadsActions,
  leadDetails,
  leadAttachmentActions,
  leadContactActions,
  leadEstimateActions,
  leadProposalActions,
  leadContractActions,
  leadFollowUpActions,
  leadNoteActions,
  leadRFIActions,
  leadTransmittalActions,
  proposalTemplate,
  contractTemplate,
  companiesActions,
  vendorsActions,
  contactsActions,
  employeesActions,
  tasksActions,
  helpActions,
  driverRequestActions,
  driverActions,
  vehiclesActions,
  usersActions,
  templatesActions,
  workOrderTemplatesActions,
  driverRequestTemplatesActions,
  materialRequestTemplatesActions,
  jobPartActions,
  organizationsActions,
  agreementActions,
  jobSiteTicketActions,
  proposalActions,
  contractActions,
  authentication,
  serviceOrderTemplatesActions,
  dashboardActions,
  activityReportActions,
  openItemsReportActions,
  purchaseOrdersReportActions,
  jobMinutesReportActions,
  toolsReportActions,
  scheduleReportActions,
  aiasReportActions,
  maintenanceFinancialsReportActions,
  paymentRequestReportActions,
  invoicesReportActions,
  activeJobContractsReportActions,
  leadsReportActions,
  proposalsSentReportActions,
  contractsSentReportActions,
  jobsReportActions,
  drawingsReportActions,
  confirmedShipmentDatesReportActions,
  transmittalsReportActions,
  rfisReportActions,
  siteWorkSchedulesReportActions,
  manufacturingScheduleReportActions,
  drawingSchedulesReportActions,
  changeOrdersReportActions,
  financialSchedulesReportActions,
  revisionActions,
  stopCallsReportActions,
  violationsReportActions,
  targetedMonthlyVisitsReportActions,
  applicationSchedulesReportActions,
  maintenanceSchedulesReportActions,
  ticketsReportActions,
  jobSiteRepairOrderActions,
  scheduledDeliveriesActions,
  testingActions
}



// WEBPACK FOOTER //
// ./src/redux/modules/index.js